import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", match: (p: string) => p === "/" },
  { to: "/rankings", label: "30条大盘点", match: (p: string) => p.startsWith("/rankings") || p.startsWith("/topic") },
  { to: "/about", label: "关于我们", match: (p: string) => p.startsWith("/about") },
  { to: "/contact", label: "联系我们", match: (p: string) => p.startsWith("/contact") },
];

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="瓜网30 首页">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-black text-lg leading-none">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-black text-lg text-foreground-950 tracking-wide">瓜网30</span>
            <span className="text-[10px] text-foreground-600 tracking-[0.2em] mt-0.5">GUAPEDIA 30</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => {
            const active = item.match(pathname);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active
                    ? "bg-primary-100 text-primary-800 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <span className="hidden lg:flex items-center gap-1.5 text-xs text-foreground-600">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line text-primary-500 text-sm"></i>
            </span>
            今日更新 6 条
          </span>
          <Link
            to="/rankings"
            className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            看完整 30 条
          </Link>
        </div>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <nav className="flex flex-col gap-1 pt-3" aria-label="移动端导航">
            {navItems.map((item) => {
              const active = item.match(pathname);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-3 rounded-md text-sm transition-colors cursor-pointer ${
                    active
                      ? "bg-primary-100 text-primary-800 font-medium"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <Link
              to="/rankings"
              className="mt-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm text-center whitespace-nowrap cursor-pointer"
            >
              看完整 30 条
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}